import React from 'react';
import { Switch, Tooltip } from 'antd';

export default function ThemeSwitch({
  dark,
  onChange,
}: {
  dark: boolean;
  onChange: (dark: boolean) => void;
}) {
  return (
    <Tooltip title={dark ? '切换为亮色主题' : '切换为暗色主题'}>
      <span
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 8,
          paddingInline: 12,
          minHeight: 40,
          color: 'inherit',
          whiteSpace: 'nowrap',
        }}
      >
        <span>主题</span>
        <Switch
          aria-label="暗色主题"
          checked={dark}
          checkedChildren="暗"
          unCheckedChildren="亮"
          onChange={onChange}
        />
      </span>
    </Tooltip>
  );
}
